<script>
import { mapGetters } from 'vuex';
import NotificationsList from './NotificationsList';

const showNumberMessage = 20;

export default {
  name: 'NotificationsListAll',
  extends: NotificationsList,
  props: {
    channel: {
      required: false,
      type: String,
    },
  },
  computed: {
    ...mapGetters('notifications', [
      'notificationSystemData',
      'notificationUpdatesData',
      'getNotificationsCountNew',
    ]),
    items() {
      return this.notificationSystemData.concat(this.notificationUpdatesData) || [];
    },
    itemsUnreadCount() {
      return this.getNotificationsCountNew();
    },
    // todo rename
    systemUnreadItems() {
      return this.notificationSystemData.filter(item => item.read_flag === false);
    },
    // todo rename
    updatesUnreadItems() {
      return this.notificationUpdatesData.filter(item => item.read_flag === false);
    },
    unreadItems() {
      if (!this.items.length) return this.items;
      const unreadItems = this.systemUnreadItems.concat(this.updatesUnreadItems);
      unreadItems.sort((a, b) => new Date(b.time) - new Date(a.time));
      return unreadItems;
    },
    readItems() {
      if (this.itemsUnreadCount >= showNumberMessage || !this.items.length) return [];
      const readItems = this.items.filter(item => item.read_flag === true);
      readItems.sort((a, b) => new Date(b.time) - new Date(a.time));
      return readItems.slice(0, showNumberMessage - this.unreadItems.length);
    },
    isShowLoadMoreLessButton() {
      return false;
    },
    groupUnreadItems() {
      return this.unreadItems.slice(0, showNumberMessage);
    },
  },
  methods: {
    onItemRead(itemId) {
      const itemToRead = this.groupUnreadItems.find(item => item.id === itemId);
      if (!itemToRead) return;
      const channel = itemToRead.channel.replace('general-', '');
      const channelUnreadCount = this.getNotificationsCountNew(channel);
      const channelLoadedItemsUnreadCount = channel === 'updates'
        ? this.updatesUnreadItems.length
        : this.systemUnreadItems.length;
      if (channelLoadedItemsUnreadCount < channelUnreadCount) {
        this.replaceJustReadNotificationByUnread({ channel, itemId });
      } else {
        this.setNotificationAsRead(itemId);
      }
    },
  },
};
</script>

<style scoped>

</style>
